import React, { Component } from 'react';
import '../css/footer.css';

class PageFooter extends Component {
   render() {
    const { contactDetails } = this.props;
    console.log(contactDetails);

    return (
        <div className="divFooter">
            <div className="col">
                <div>
                    <p></p>
                    Copyright &copy; 2019 <span id="comp">Experts Service Management LLC</span><br />
                    Website developed by <span id="comp">Universal Telecomunication Systems</span>
                </div>
            </div>
            <div className="col">
                <div className="subcol">
                    <p>Company Office</p>
                    <strong>Tel:</strong> {contactDetails[0].phone}<br />
                    <strong>Mob:</strong> {contactDetails[0].mobile}<br />
                
                    
                </div>
                <div className="subcol">
                    <p><strong>Postal Address</strong></p>
                    {contactDetails[0].post1}<br />
                    {contactDetails[0].post2}<br />
                    email: <a href={"mailto:"+contactDetails[0].email}>{contactDetails[0].email}</a>
                </div>
                
            </div>
        </div>
      );
   }
}

export default PageFooter;